exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.text-muted{\n  font-size:11px;\n  color:#839bb3 !important;\n  padding-left:5px\n}\n.vs-input--label{\n  font-size:14px\n}", ""]);

// exports
